<template>
    <div class="layout-cabinet-sideblock-userinfo">
        <template v-if="user && user !== 'guest'">
            <div class="layout-cabinet-sideblock-userinfo__name">
                <span class="layout-cabinet-sideblock-userinfo__name-last">
                    {{ user.firstName }} {{ user.lastName }}
                </span>
                <span class="layout-cabinet-sideblock-userinfo__name-qi" v-if="user.isQualifiedInvestor">
                    <VTooltip
                        :distance="6"
                        :triggers="['click', 'hover']"
                        placement="right"
                    >
                    <icon name="sign-check" original />
                    <template #popper>
                        <p style="max-width: 300px; font-size: 14px;">
                            Квалифицированный инвестор
                        </p>
                    </template>
                </VTooltip>
                </span>
            </div>
            <div class="layout-cabinet-sideblock-userinfo__email">
                <span v-text="user.email" />
            </div>
        </template>
        <template v-else>
            <div class="layout-cabinet-sideblock-userinfo__name">
                Гость
            </div>
        </template>
    </div>
</template>

<script>
export default {
    name: 'layout-cabinet-sideblock-userinfo',
    computed: {
        user() {
            return this.$store.getters['users/user'];
        },
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.layout-cabinet-sideblock-userinfo {
    flex: 1 1 auto;
    padding-bottom: 24px;
    margin-bottom: auto;
    &__name {
        .typography-heading();

        margin-bottom: 9px;

        line-height: 1.8rem;
        &-last {
            margin-right: 4px;
        }
        &-qi {
            display: inline-block;

            font-size: 1.4rem;
            vertical-align: middle;
            &:hover {
                position: relative;
            }
        }
    }
    &__email {
        .typography-caption();

        margin-left: 1px;

        color: @color-gray-main;
    }
    @media @media-md-down {
        display: none;
    }
}
</style>
